import React from "react";
import SearchIcon from "../../assets/images/search.png";
import CancelSearchIcon from "../../assets/images/cancel-search.png";
import { SearchProps } from "./types";

export default function Search({
  value,
  onChange,
  onClear,
  placeholder = "Search by keywords",
}: SearchProps) {
  return (
    <div className="relative w-[290px]">
      <input
        placeholder={placeholder}
        className="w-full h-10 rounded-full pl-11 pr-10 text-[13px] text-[#8A8A8A] outline-none placeholder:text-[#9AA7BC] border border-[#000000]"
        value={value}
        onChange={onChange}
      />
      <img
        src={SearchIcon}
        alt="Search"
        className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4"
      />
      {value && (
        <button
          onClick={onClear}
          className="absolute right-3 top-1/2 -translate-y-1/2"
          aria-label="Clear search"
          type="button"
        >
          <img src={CancelSearchIcon} alt="Cancel Search" className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}
